import React from "react";

const pollutantRows = [
  "NOx",
  "SOx",
  "Particulate matter (PM)",
  "Persistent organic pollutants (POP)",
  "Volatile organic compounds (VOC)",
  "Hazardous air pollutants (HAP)",
  "Others – please specify",
];

const defaultAirPollutantData = pollutantRows.map((param) => ({
  parameter: param,
  unit: "",
  current: "",
  previous: "",
}));

const AirPollutantEmissionTable = ({ airdata, setAirData }) => {
  const data = airdata && airdata.length ? airdata : defaultAirPollutantData;

  const handleChange = (index, key, value) => {
    const updated = [...data];
    updated[index][key] = value;
    setAirData(updated);
  };

  return (
    <div
      style={{
        marginTop: 20,
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#d3c9ce", fontWeight: "bold" }}>
            <th style={headerStyle}>Parameter</th>
            <th style={headerStyle}>Unit</th>
            <th style={headerStyle}>
              FY _____
              <br />
              Current Financial Year
            </th>
            <th style={headerStyle}>
              FY _____
              <br />
              Previous Financial Year
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx}>
              <td style={labelCellStyle}>{row.parameter}</td>
              <td style={cellStyle}>
                <input
                  type="text"
                  placeholder="Unit"
                  value={row.unit}
                  onChange={(e) => handleChange(idx, "unit", e.target.value)}
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  placeholder="Current FY"
                  value={row.current}
                  onChange={(e) => handleChange(idx, "current", e.target.value)}
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  placeholder="Previous FY"
                  value={row.previous}
                  onChange={(e) =>
                    handleChange(idx, "previous", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const labelCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  fontWeight: 600,
  backgroundColor: "#f4f1f3",
  textAlign: "left",
};

const cellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputStyle = {
  width: "90%",
  padding: "8px",
  fontSize: "14px",
  border: "1px solid grey",
  borderRadius: "4px",
  outline: "none",
};

export default AirPollutantEmissionTable;
